import i18next from "i18next";
import { ContainerBatteryStatusEnum } from "../../storeMap/enums/ContainerBatteryStatusEnum";

export const ContainerBatteryStatusEnumToString = (batteryStatus: ContainerBatteryStatusEnum) => {
    const t = (key: string) => i18next.t(key, { ns: "admin" }) as string;
    switch (batteryStatus) {
        case ContainerBatteryStatusEnum.NoInfo:
            return t("containers.batteryStatus.0");
        case ContainerBatteryStatusEnum.Normal:
            return t("containers.batteryStatus.1");
        case ContainerBatteryStatusEnum.Low:
            return t("containers.batteryStatus.2");
        case ContainerBatteryStatusEnum.Critical:
            return t("containers.batteryStatus.3");
    }
}

export const ContainerBatteryStatusEnumToStringFirstCapitalLetter = (batteryStatus: ContainerBatteryStatusEnum) => {
    let result = ContainerBatteryStatusEnumToString(batteryStatus)
    return capitalizeFirstLetter(result);
}

function capitalizeFirstLetter(text: string) {
    return text.charAt(0).toUpperCase() + text.slice(1);
}